"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContactEmails;
(function (ContactEmails) {
    ContactEmails["CUSTOMER_SERVICE_EMAIL"] = "customerservice@auction.com";
    ContactEmails["SMART_SALE_CONCIERGE"] = "PrivateSellerTeam@auction.com";
})(ContactEmails || (ContactEmails = {}));
exports.default = ContactEmails;
//# sourceMappingURL=contactEmails.js.map